<ng-template [ngIf]="widgets != null">
  <!-- Header Config Goes here -->
  <div class="row" *ngIf="showHeader != false">
    <div [ngClass]="hideDelete == true ? 'col-12' : 'col-11'">
      <div class="row">
        <div *ngFor="let hc of headerConfig" [ngClass]="'col-' + hc.size">
          <h6>{{ hc.name }}</h6>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngFor="let fc of widgets">
    <ng-container *ngIf="hideDelete == true; else showDelete">
      <div class="col-12">
        <app-srs-multi-element-widget [config]="fc"></app-srs-multi-element-widget>
      </div>
    </ng-container>
    <ng-template #showDelete>
      <div class="col-11">
        <app-srs-multi-element-widget [config]="fc"></app-srs-multi-element-widget>
      </div>
      <!-- Auto Resize Button -->
      <div class="col-1 d-flex align-items-center" *ngIf="canDeleteRow(fc)">
        <button class="btn btn-primary" (click)="removeRow(fc)">X</button>
      </div>
    </ng-template>
  </div>

  <!-- Having issues handling button scaling and header positioning -->
  <!-- <div class="col-12">
    <div class="d-flex" *ngFor="let fc of widgets">
      <div class="flex-grow-1">
        <app-srs-multi-element-widget [config]="fc"></app-srs-multi-element-widget>
      </div>
      <div *ngIf="canDelete(fc)">
        <button class="btn btn-primary" (click)="removeRow(fc)">X</button>
      </div>
    </div>
  </div> -->
</ng-template>
